import React, { useMemo } from "react"
import { WebGLRenderTarget } from "three"
import BackfaceMaterial from "./BackfaceMaterial"
import RefractionMaterial from "./RefractionMaterial"
import { useThree } from "@react-three/fiber"
import useContentStore from "../redux/stores/contentStore"

export default function useMaterials(){
    const content = useContentStore((state) => state.content);

    const {
        size,
        gl,
    } = useThree();
    const ratio = gl.getPixelRatio();

    const materials = useMemo(() => {
        const envFbo = new WebGLRenderTarget(size.width * ratio, size.height * ratio)
        const backfaceFbo = new WebGLRenderTarget(size.width * ratio, size.height * ratio)
        const backfaceMaterial = new BackfaceMaterial()
        const refractionMaterial = new RefractionMaterial({
            envMap: envFbo.texture,
            backfaceMap: backfaceFbo.texture,
            resolution: [size.width * ratio, size.height * ratio]
        })
        return [envFbo, backfaceFbo, backfaceMaterial, refractionMaterial]
    }, [size, ratio]);

    return materials;
}
